import type { ContactQueryKey, UseContactParams } from '../types';

export const getContactQueryKey = (
  params: UseContactParams,
): ContactQueryKey => {
  return ['contacts', 'contact', params];
};
